import api from "@/api";
import apiad from "@/apiad";
import router from "@/router";

export default {
  namespaced: true,

  state: {
    token: localStorage.getItem("apiToken") || null,
    username: "",
    password: "",
    authErrors: [],
    success: false,
    superAdmin: true,
    loading: false,
    currentUser: {},
    userId: parseInt(localStorage.getItem("userId")) || null,
  },

  mutations: {
    setToken(state, token) {
      state.token = token;
    },

    clearToken(state) {
      state.token = null;
    },

    setUsername(state, username) {
      state.username = username;
    },

    setPassword(state, password) {
      state.password = password;
    },

    setAuthErrors(state, authErrors) {
      state.authErrors = authErrors;
    },

    setCurrentUser(state, user) {
      state.currentUser = Object.assign({}, user);
    },

    setUserId(state, userId) {
      state.userId = userId;
    },
    setSuperAdmin(state, isAdmin) {
      state.superAdmin = isAdmin;
    },
  },

  actions: {
    async login({ commit, state, dispatch }, token) {
      state.loading = true;
      let response;

      try {
        response = await api({
          auth: {
            username: state.username,
            password: state.password,
          },
        }).get("/token");
        const newToken = response.data.meta.token;

        if (newToken) {
          commit("setAuthErrors", []);
          state.success = true;
          commit("setToken", newToken);
          localStorage.setItem("apiToken", newToken);
          dispatch("listCurrentUser");
          router.push("/dashboard");
          return Promise.resolve();
        }
      } catch (error) {
        if (!error.status) {
          commit("setAuthErrors", [
            { message: "Sorry, there was an error.  Please try again" },
          ]);
          dispatch("logout");
          router.push("/login");
        }
        if (error.response) {
          state.loading = false;
          state.password = "";
          commit("setAuthErrors", [
            { message: error.response.data.error.message },
          ]);
        }
        setTimeout(() => {
          if (state.token) {
            router.push("/dashboard");
          }
        }, 1000);
        return Promise.reject();
      }
    },

    async adlogin({ commit, state, dispatch }) {
      state.loading = true;
      let response;
      try {
        response = await apiad().get("/adtoken");

        const { token } = response.data.meta;

        if (token) {
          commit("setAuthErrors", []);
          state.success = true;
          commit("setToken", token);
          localStorage.setItem("apiToken", token);
          dispatch("listCurrentUser");
          return Promise.resolve();
        }
      } catch (error) {
        state.loading = false;
        if (error.response) {
          dispatch("logout");
          router.push("/login");
        }
      }
      return Promise.reject();
    },

    async azureLogin({ commit, dispatch, state }, token) {
      state.loading = true;
      let response;

      try {
        response = await api().post("/auth/azure/token", null, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const newToken = response.data.meta.token;

        if (newToken) {
          commit("setAuthErrors", []);
          state.success = true;
          commit("setToken", newToken);
          localStorage.setItem("apiToken", newToken);
          dispatch("listCurrentUser");
          router.push("/dashboard");
          return Promise.resolve();
        }
      } catch (error) {
        if (!error.status) {
          commit("setAuthErrors", [
            { message: "Sorry, there was an error.  Please try again" },
          ]);
          dispatch("logout");
          router.push("/login");
        }
        if (error.response) {
          state.loading = false;
          state.password = "";
          commit("setAuthErrors", [
            { message: error.response.data.error.message },
          ]);
        }
        setTimeout(() => {
          if (state.token) {
            router.push("/dashboard");
          }
        }, 1000);
        return Promise.reject();
      }
    },

    async checkToken({ commit, state, dispatch }, token) {
      const adDomain = process.env.VUE_APP_AD_DOMAIN;
      try {
        const response = await api().get("/checktoken");
        return Promise.resolve();
      } catch (err) {
        if (adDomain) {
          try {
            await dispatch("adlogin");
            return Promise.resolve();
          } catch (adErr) {
            return Promise.reject();
          }
        } else {
          return Promise.reject();
        }
      }
    },

    async handleAzureLogin(context) {
      let currentUser;
      let currentAccounts;
      let tokenResponse;

      try {
        await this._vm.$msal.handleRedirectPromise();
        currentAccounts = await this._vm.$msal.getAllAccounts();
        currentUser = currentAccounts[0];

        if (currentUser) {
          localStorage.setItem("msal_user", JSON.stringify(currentUser));

          // build payload for silent request
          const silentRequest = {
            scopes: [],
            account: currentUser,
            forceRefresh: false,
          };

          tokenResponse = await this._vm.$msal
            .acquireTokenSilent(silentRequest)
            .catch((error) => {
              if (error instanceof InteractionRequiredAuthError) {
                const request = {
                  loginHint: currentUser.username,
                  scopes: [],
                };
                // fallback to interaction when silent call fails
                return Promise.resolve(
                  this._vm.$msal.acquireTokenRedirect(request)
                );
              }
            });
        }
        return Promise.resolve(tokenResponse);
      } catch (err) {
        return Promise.reject(err);
      }
    },

    async logout({ commit, state, dispatch }) {
      commit("clearToken");
      state.success = false;
      state.loading = false;
      state.password = "";
      const msalUser = localStorage.getItem("msal_user")
      localStorage.clear();
      //clear dashboard config
      try {
        dispatch("widgets/clearDashboard", null, { root: true });
      } catch (err) {}
      // need to logout of msal too
      if (msalUser) {
        const logoutRequest = {
          account: this._vm.$msal.getAccountByUsername(msalUser.username),
        };

        await this._vm.$msal.logout(logoutRequest);
      }
    },

    listCurrentUser({ commit }) {
      return new Promise((resolve, reject) => {
        api()
          .get("/currentuser")
          .then((response) => {
            if (response.data.data.user) {
              const currentUser = response.data.data.user[0];
              commit("setCurrentUser", currentUser);
              commit("setUserId", currentUser.id);
              // are we a super user?
              let superUser = true;
              Object.keys(currentUser.privileges).forEach((val, key) => {
                if (!currentUser.privileges[val]) {
                  superUser = false;
                }
              });
              commit("setSuperAdmin", superUser);
              localStorage.setItem("userId", currentUser.id);
              resolve(currentUser);
            }
          });
      });
    },
  },

  getters: {
    loggedIn(state) {
      if (state.token) {
        return true;
      }
      return false;
    },
  },
};